import { render } from "./AccountRelatedPage.vue?vue&type=template&id=735cec9a&scoped=true"
import script from "./AccountRelatedPage.vue?vue&type=script&lang=js"
export * from "./AccountRelatedPage.vue?vue&type=script&lang=js"

import "./AccountRelatedPage.vue?vue&type=style&index=0&id=735cec9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735cec9a"]])

export default __exports__